import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.comments.edit;

export const commentEditShowModal = createSelector([baseState], (state) => {
    return !!state.type && !!state.resource_id && !!state.comment
});
export const commentEditData = createSelector([baseState], (state) => {
    return {
        type: state.type,
        id: state.resource_id,
        comment_id: (state.comment || {}).id
    }
});
export const commentEditLoading = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const commentEditErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});

